import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type CourseAuthor = {
   author: number;
   username: string;
};

export type GetCourseAuthorsRequestOptions = CommonRequestOptions & {
   orderby?: 'username';
   direction?: 'ASC' | 'DESC';
   page?: number;
   pageSize?: number;
   search?: string;
};

export type GetCourseAuthorsResult = {
   authors: CourseAuthor[];
   total: number;
   hasMore: boolean;
};

export async function getCourseAuthors({
   orderby,
   direction,
   page,
   pageSize,
   search,
   ...common
}: GetCourseAuthorsRequestOptions): Promise<GetCourseAuthorsResult> {
   return makeRequest('get', 'courses/authors', {
      ...common,
      query: {
         orderby,
         direction,
         page,
         pageSize,
         search,
      },
   });
}
